///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserAuthorities } from '../../../services/user/user-authorities';
import { GtthExportService } from '../../../services/project/export.service';
import { EngineProcessTypeEnum, ProjectDTO } from '../../../generated/shared-types.model';

@Component({
    selector: 'winde-project-control-btns',
    templateUrl: './project-controls.component.html',
    styleUrls: ['../projects-list.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthProjectControlsComponent {
    public showInfo: boolean;
    public isInfoHighLight = false;
    public userAuthorities = UserAuthorities;
    @Input() project: ProjectDTO;
    @Input() controlsClass: string;
    protected readonly EngineProcessTypeEnum = EngineProcessTypeEnum;

    constructor(private readonly exportService: GtthExportService) {}

    public _searchFilter: string;

    @Input() set searchFilter(value: string) {
        this._searchFilter = value;
        this.checkInfoHighLight();
    }

    public exportProjectFilesArchive(projectId: number): void {
        this.exportService.exportProjectFilesArchive(projectId);
    }

    private checkInfoHighLight() {
        if (this.project.description && this._searchFilter) {
            const description = this.project.description.toLowerCase();
            this.isInfoHighLight = !!RegExp(this._searchFilter.toLowerCase()).exec(description);
        } else {
            this.isInfoHighLight = false;
        }
    }
}
